import api, { getErrorMessage } from './api';

/**
 * Workvivo SAML SSO admin config (org inferred from the authenticated admin's JWT;
 * superusers may pass `orgId` to act on another organization).
 * The public per-org status endpoint powers the "Sign in with Workvivo" button.
 */
const workvivoSamlService = {
  /**
   * Get this org's SAML config + the SP URLs to hand to the Workvivo admin.
   * @returns {Promise<{has_integration:boolean, saml_sso_enabled:boolean,
   *   saml_idp_metadata_url:string|null, sp_entity_id:string, acs_url:string,
   *   sp_metadata_url:string}>}
   */
  getConfig: async (orgId) => {
    try {
      const response = await api.get('/api/v1/admin/workvivo/saml', {
        params: orgId ? { org_id: orgId } : {},
      });
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },

  /**
   * Enable/disable SAML SSO and set the Workvivo IdP metadata URL.
   * @param {{saml_sso_enabled:boolean, saml_idp_metadata_url:string|null}} data
   */
  updateConfig: async (data, orgId) => {
    try {
      const response = await api.put('/api/v1/admin/workvivo/saml', data, {
        params: orgId ? { org_id: orgId } : {},
      });
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },

  /**
   * Public: whether SAML SSO is enabled for an org (gates the login button).
   * @param {string} orgId - Organization UUID
   * @returns {Promise<{enabled:boolean}>}
   */
  getStatus: async (orgId) => {
    try {
      const response = await api.get(`/api/v1/auth/sso/saml/${orgId}/status`);
      return response.data;
    } catch (error) {
      return { enabled: false };
    }
  },
};

export default workvivoSamlService;
